import React from 'react';
import './PopUp.scss';
import { View20 } from '@carbon/icons-react';

interface popUpProps {
  contents: any;
}

const PopUp = (popUpProps: popUpProps) => {
  const { contents } = popUpProps;
  const parentClass = 'dora-assessment__pop-up';
  return (
    <div className={parentClass}>
      <div className={`${parentClass}-icon`}>
        <View20 />
      </div>

      <div className={`${parentClass}-contents`}>
        <p>{contents.popUpText}</p>
        {contents.popUpList ? (
          <ol>
            {contents.popUpList.map((item: JSX.Element, i: number) => (
              <div className={`${parentClass}-list-item`}>
                <span>{i + 1}.</span>
                <li>{item}</li>
              </div>
            ))}
          </ol>
        ) : null}
      </div>
    </div>
  );
};

export default PopUp;
